import React from 'react';
import { createIcon } from '@chakra-ui/react';

export function createLocationPermissionIcon(fillColor = '#9FA0A4') {
  return createIcon({
    displayName: 'LocationPermissionIcon',
    path: (
      <svg width="223" height="223" viewBox="0 0 223 223" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.8" cx="110.5" cy="111.5" r="102.5" fill="url(#paint0_radial_43447_36711)" />
        <circle cx="110.5" cy="111.5" r="79.5" stroke={fillColor} strokeWidth="2" />
        <path
          d="M145.124 145.11C145.115 145.042 143.401 138.559 143.401 138.559C143.165 137.67 142.253 137.14 141.363 137.376C140.473 137.612 139.944 138.524 140.18 139.414L141.001 142.508L127.185 136.799V121.624H135.461L136.341 124.941C136.539 125.688 137.213 126.181 137.95 126.181C138.092 126.181 138.236 126.163 138.379 126.125C139.268 125.889 139.798 124.976 139.562 124.087L138.353 119.53C138.16 118.8 137.499 118.291 136.743 118.291H119.169L129.237 100.853C133.316 93.7868 133.317 85.3501 129.237 78.2843C125.158 71.2184 117.851 67 109.692 67C101.533 67 94.2269 71.2183 90.1473 78.2843C86.0679 85.3501 86.0679 93.7868 90.1473 100.853L100.215 118.291H84.3973C83.6416 118.291 82.9803 118.8 82.7866 119.53L76.0557 144.906C75.9231 145.406 76.0301 145.94 76.3456 146.35C76.6611 146.76 77.149 147 77.6662 147H143.459C144.46 147.01 145.259 146.098 145.124 145.11ZM123.852 121.624V135.422L112.086 130.559L117.245 121.624H123.852ZM93.0334 99.1862C89.5564 93.1638 89.5564 85.9729 93.0334 79.9505C96.5105 73.9281 102.738 70.3327 109.692 70.3327C116.646 70.3327 122.874 73.9281 126.351 79.9505C129.828 85.9729 129.828 93.1638 126.351 99.1862L109.692 128.04L93.0334 99.1862ZM85.6794 121.624H102.14L106.806 129.706H83.5355L85.6794 121.624ZM79.8323 143.667L82.6514 133.039H94.6865L105.315 143.667H79.8323ZM110.028 143.667L99.3999 133.039H109.362L135.079 143.667H110.028Z"
          fill={fillColor}
        />
        <path
          d="M140.742 133.258C141.549 132.817 141.845 131.807 141.404 131C140.963 130.194 139.952 129.898 139.146 130.339C138.34 130.779 138.044 131.79 138.485 132.596C138.925 133.403 139.936 133.699 140.742 133.258Z"
          fill={fillColor}
        />
        <path
          d="M120.656 89.2643C120.656 83.1242 115.66 78.1289 109.52 78.1289C103.38 78.1289 98.3848 83.1242 98.3848 89.2643C98.3848 95.4045 103.38 100.4 109.52 100.4C115.66 100.4 120.656 95.4045 120.656 89.2643ZM109.52 97.0671C105.218 97.0671 101.717 93.5668 101.717 89.2643C101.717 84.9619 105.218 81.4616 109.52 81.4616C113.823 81.4616 117.323 84.9619 117.323 89.2643C117.323 93.5668 113.823 97.0671 109.52 97.0671Z"
          fill={fillColor}
        />
        <defs>
          <radialGradient
            id="paint0_radial_43447_36711"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(110.5 111.5) rotate(89.7178) scale(101.501)"
          >
            <stop offset="0.836438" stopOpacity="1" />
            <stop offset="0.836538" stopColor={fillColor} stopOpacity="0.9" />
            <stop offset="1" stopColor={fillColor} stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>
    ),
    viewBox: '0 0 234 234',
  });
}
